import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { poll } from '~/utils/poll/poll'
import type { PollOptions } from '~/utils/poll/poll.types'

import { POLL_UPLOAD_CANCELLED } from './useAttachmentUpload.constants'

const INTERVAL_IN_MS = 1000
const MAX_ATTEMPTS = 180

export type UploadStatusResponse = {
  data: {
    status: string
    bucket_name: string
    file_path: string
    status_reason?: string
  }
}

export function usePollUploadMetadata() {
  const $httpFetch = useHttpFetch()

  async function pollUploadMetadata(
    handle: string,
    abortSignal?: AbortSignal,
    options: PollOptions = { interval: INTERVAL_IN_MS, retries: MAX_ATTEMPTS },
  ): Promise<UploadStatusResponse> {
    return poll(async () => {
      try {
        if (abortSignal?.aborted) {
          throw new Error(POLL_UPLOAD_CANCELLED)
        }

        const uploadMetadata = await $httpFetch('/services/uploads/:handle', {
          pathParams: { handle },
        })

        if (uploadMetadata?.data?.status === 'pending') {
          throw new Error('Upload not ready')
        }

        return uploadMetadata
      } catch (err) {
        throw new Error('Upload failed while polling upload metadata')
      }
    }, options)
  }

  return {
    pollUploadMetadata,
  }
}
